import { LegalTermsSummary } from '../../../models/LegalTermsSummary/legal-terms-summary.model';
import { getApiErrorDetail } from '../../../utils/getApiErrorDetail';

const ConflictStatusCode = 409;

export async function fetchLegalTermsSummary(
    axios: { get: (url: string) => Promise<{ data: LegalTermsSummary; status: number }> },
    engagementId: number
): Promise<LegalTermsSummary> {
    const response = await axios.get(
        `/api/LegalTermsSummary/${engagementId}`
    );
    if (response.status !== 200) {
        throw new Error('Failed to fetch legal terms summary');
    }
    return response.data as LegalTermsSummary;
}

export async function updateLegalTermRowComment(
    axios: {
        put: (
            url: string,
            data: { comment: string | null }
        ) => Promise<{ data: LegalTermsSummary; status: number }>;
    },
    engagementId: number,
    rowId: number,
    comment: string | null
): Promise<LegalTermsSummary> {
    const response = await axios.put(
        `/api/LegalTermsSummary/${engagementId}/Rows/${rowId}/Comment`,
        { comment }
    );
    if (response.status !== 200) {
        throw new Error(getApiErrorDetail(response) ?? 'Failed to save the comment');
    }
    return response.data as LegalTermsSummary;
}


export async function updateLegalTermRowInterpretation(
    axios: {
        put: (
            url: string,
            data: { value: string | null }
        ) => Promise<{ data: LegalTermsSummary; status: number }>;
    },
    engagementId: number,
    rowId: number,
    value: string | null
): Promise<LegalTermsSummary> {
    const response = await axios.put(
        `/api/LegalTermsSummary/${engagementId}/Rows/${rowId}/Interpretation`,
        { value }
    );
    if (response.status !== 200) {
        throw new Error(getApiErrorDetail(response) ?? 'Failed to save the interpretation');
    }
    return response.data as LegalTermsSummary;
}


